/* eslint-disable react/prop-types */
import Link from 'next/link'
import Column from '../../layout/Column'
import Columns from '../../layout/Columns'
import styles from './styles.module.scss'
import HouseDetails from '../../custom/HouseDetails'
import ArrowPrev from '/public/icons/icon-screenshots-prev.svg'
import ArrowNext from '/public/icons/icon-screenshots-next.svg'
import IconFavourite from '/public/icons/icon-favourite.svg'
import { useState, useEffect } from 'react'
import SlickSlider from '../SlickSlider'
import { withModifiers } from '../../helpers/withModifiers'
import { useRouter } from 'next/router'
import { useSearchContext } from '../../../providers/SearchContext'
import capitalize from 'lodash-es/capitalize'
import isEmpty from 'lodash-es/isEmpty'
import isNumber from 'lodash-es/isNumber'
import toNumber from 'lodash-es/toNumber'
import { withComma } from '../../helpers/withComma'
import { getS3Url } from '../../helpers/getS3Url'
import { useResponsive } from '../../../providers/ResponsiveContext'
import { useFavouritesContext } from '/providers/favouritesProvider'
import Button from '../Button'
import Image from 'next/image'
import LazyImage from '../LazyImage'

const Card = ({
  nickname,
  city,
  propertyType,
  variant = [],
  accommodates,
  bedrooms,
  bathrooms,
  cardRef,
  picture,
  pictures,
  setHovered,
  propertyTitle,
  resource_id,
  is_exclusive,
  startingAt,
  total,
  id,
  gallery,
  cloudflare_gallery,
  welcome_description,
  propertyDescription,
  min_price,
  promotional,
  translations,
  card_label
}) => {
  const isShort = variant.includes('short')
  const { search } = useSearchContext()
  const { addOrRemoveFavourite, isFavourite } = useFavouritesContext()
  const router = useRouter()
  const { isLargeDesktop } = useResponsive()
  const propertyName = `${nickname}-${bedrooms}-bedroom-${propertyType?.en?.toLowerCase()}`

  const [label, setLabel] = useState(true)
  useEffect(() => {
    if (router.pathname === '/vacation-rentals') {
      if (search.startDate && search.endDate) {
        setLabel(false)
      } else {
        setLabel(true)
      }
    }
  }, [search.bedrooms])

  function formatBathrooms(bathrooms) {
    if (!bathrooms) return ''

    // Handle string expressions like "4 +0.5 + 0.5"
    if (typeof bathrooms === 'string' && bathrooms.includes('+')) {
      // Split by '+', convert each part to a number, and sum them
      const sum = bathrooms
        .split('+')
        .map((part) => parseFloat(part.trim()) || 0)
        .reduce((total, num) => total + num, 0)

      // Format the result - add .0 for whole numbers ONLY in calculation case
      return sum % 1 === 0
        ? sum.toFixed(1)
        : sum.toString().replace(/\.0+$/, '')
    }

    // Handle regular numbers (whether they come in as string or number)
    // First ensure we have a proper number
    const num =
      typeof bathrooms === 'string'
        ? parseFloat(bathrooms)
        : toNumber(bathrooms)

    // Then format - NO .0 suffix for these cases
    return num % 1 === 0 ? num.toString() : num.toString().replace(/\.0+$/, '')
  }

  const renederedGallery =
    cloudflare_gallery && !isEmpty(cloudflare_gallery)
      ? cloudflare_gallery
      : gallery && !isEmpty(gallery) && gallery

  if (bedrooms && nickname && propertyType) {
    return (
      <div
        onMouseEnter={() => setHovered && setHovered(resource_id)}
        onMouseLeave={() => setHovered && setHovered(false)}
        ref={cardRef}
        className={withModifiers(
          'card',
          [...variant, promotional && 'promo'],
          styles
        )}
      >
        <div className={styles.card__header}>
          {renederedGallery && renederedGallery.length && (
            <Link
              href={`/vacation-rentals/${nickname}-${bedrooms}-bedroom-${
                propertyType?.en?.toLowerCase() ||
                propertyType?.toLowerCase() ||
                'property'
              }`}
            >
              <a className={styles.card__link}>
                <SlickSlider
                  nextArrow={<ArrowNext />}
                  prevArrow={<ArrowPrev />}
                  slidesToShow={1}
                  pagination={true}
                  className={styles.card__slider}
                >
                  {renederedGallery
                    ? renederedGallery
                        .slice(
                          0,
                          renederedGallery.length < 7
                            ? renederedGallery.length
                            : 7
                        )

                        .map((item, index) => (
                          <div key={index}>
                            <LazyImage
                              src={getS3Url(item, '640')}
                              alt={`Property presentation image ${index}`}
                              width={590}
                              height={392}
                              sizes="(min-width: 1250px) 588px, (max-width: 1250px) 640px, (max-width: 400px) 400px,
            50vw"
                            />
                          </div>
                        ))
                    : pictures && Array.isArray(pictures) && pictures.length > 0
                    ? pictures.slice(0, 7).map((item, index) => (
                        <div key={`${nickname}-${index}`}>
                          <LazyImage
                            alt={`Property presentation image ${index}`}
                            src={item.large || item.original || item}
                            width={590}
                            height={392}
                            className={styles.image}
                            sizes="(min-width: 1250px) 588px, (max-width: 1250px) 640px, (max-width: 400px) 400px,
            50vw"
                          />
                        </div>
                      ))
                    : null}
                </SlickSlider>
              </a>
            </Link>
          )}

          {picture?.thumbnail && !renederedGallery && (
            <Link href={`/vacation-rentals/${propertyName}`}>
              <a>
                <Image
                  src={picture.thumbnail}
                  alt={`${
                    propertyTitle || nickname || 'Property'
                  } presentation image`}
                  width={590}
                  sizes="(min-width: 1250px) 588px, (max-width: 1250px) 640px, (max-width: 400px) 400px, 50vw"
                  height={393}
                  quality={85}
                  placeholder="blur"
                  blurDataURL="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAABAAEDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAUEAEAAAAAAAAAAAAAAAAAAAAA/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAX/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwCwABmX/9k="
                />
              </a>
            </Link>
          )}

          {/* Fallback placeholder when no images available */}
          {!renederedGallery &&
            !picture?.thumbnail &&
            pictures &&
            Array.isArray(pictures) &&
            pictures.length > 0 &&
            pictures[0] && (
              <Link href={`/vacation-rentals/${propertyName}`}>
                <a>
                  <LazyImage
                    src={
                      pictures[0].large ||
                      pictures[0].original ||
                      pictures[0].thumbnail ||
                      pictures[0]
                    }
                    alt={`${
                      propertyTitle || nickname || 'Property'
                    } presentation image`}
                    width={590}
                    height={393}
                    sizes="(min-width: 1250px) 588px, (max-width: 1250px) 640px, (max-width: 400px) 400px, 50vw"
                  />
                </a>
              </Link>
            )}

          <div className={styles.card__type}>
            {card_label
              ? card_label
              : is_exclusive === 1
              ? translations?.exclusive?.[router.locale]
              : propertyType?.[router.locale] || propertyType?.en || 'Property'}
          </div>

          <Button
            aria-label="Add to favourite"
            prepend={<IconFavourite width={24} />}
            onClick={() => addOrRemoveFavourite(id)}
            arrow={false}
            variant={['label']}
            className={withModifiers(
              'card__favourite',
              [isFavourite(id) && 'is-active'],
              styles
            )}
          ></Button>
        </div>

        <Link href={`/vacation-rentals/${propertyName}`}>
          <a className={styles.card__link}>
            <div className={styles.card__content}>
              {promotional && (
                <div className={styles.card__discount}>
                  {translations?.promo[router.locale]}
                </div>
              )}

              {city && (
                <span className={styles.card__location}>
                  {city?.replace(/-/g, ' ')}
                </span>
              )}
              {(propertyTitle || nickname) && (
                <h2 className={styles.card__title}>
                  {propertyTitle
                    ? propertyTitle
                    : nickname.replace(/\w+/g, capitalize).replaceAll('-', ' ')}
                </h2>
              )}

              {!isShort &&
                (welcome_description || propertyDescription !== "' ' ") && (
                  <p
                    dangerouslySetInnerHTML={{
                      __html: welcome_description || propertyDescription
                    }}
                    className={styles.card__description}
                  ></p>
                )}
            </div>

            <div className={styles.card__footer}>
              <Columns
                variant={['-align-center', '-distribute-between', 'no-gutter']}
              >
                <Column variant={['no-padding', 'align-middle']}>
                  <HouseDetails
                    variant={[(isShort || isLargeDesktop) && 'close']}
                    bedrooms={isNumber(bedrooms) ? bedrooms : bedrooms.length}
                    bathrooms={formatBathrooms(bathrooms)}
                    persons={accommodates}
                  />
                </Column>

                <Column variant={['no-padding']}>
                  <div className={styles.card__price}>
                    <span
                      style={{ opacity: label && 1 }}
                      className={styles.card__starting}
                    >
                      {translations?.startingAt[router.locale]}
                    </span>

                    <span className={styles.card__number}>
                      $
                      {router.pathname === '/vacation-rentals'
                        ? startingAt
                          ? withComma(startingAt)
                          : withComma(min_price || total)
                        : withComma(min_price || total)}
                    </span>

                    {!(search.startDate && search.endDate) && '/pn'}
                  </div>
                </Column>
              </Columns>
            </div>
          </a>
        </Link>
      </div>
    )
  }

  return
}

export default Card
